export const GET_LEADFEEDBACKTYPES = "GET_LEADFEEDBACKTYPES";
export const ADD_LEADFEEDBACKTYPE = "ADD_LEADFEEDBACKTYPE";
export const EDIT_LEADFEEDBACKTYPE = "EDIT_LEADFEEDBACKTYPE";
export const GET_LEADFEEDBACKTYPE = "GET_LEADFEEDBACKTYPE";
export const RESET_LEADFEEDBACKTYPE = "RESET_LEADFEEDBACKTYPE";
export const ERROR_LEADFEEDBACKTYPE = "ERROR_LEADFEEDBACKTYPE";
export const GET_ALL_LEADFEEDBACKTYPES = "GET_ALL_LEADFEEDBACKTYPES";
                